
import SmartCar from "../../../assets/duotone/SmartCar.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmartCarIcon({ className, dataTestid = "SmartCarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmartCar data-testid={dataTestid} className={classes} {...rest} />
  );
}
